<app-loggedin-account-header></app-loggedin-account-header>
<div class="backlock" *ngIf="lockScreen" (click)="onLockScreenHide()"></div>
<div
  class="mapfre-content container loggedin"
  [ngClass]="{
    'is-Acmic navbar-body-height': isAcmic,
    'is-Acmic-not': !isAcmic,
    'dashboard-margin-top': onDashboard,
    'main-card-width': !isAcmic && onHomePage()
  }"
>
  <div
    class="row contentBox no-margin"
    [ngClass]="{ 'dashboard-main-mobile ': !isAcmic }"
  >
    <div class="col-auto no-padding w-100-mobile w-100-tab">
      <app-loggedin-sidenav
        (lockScreen)="lockScreenEvent($event)"
        [showMore]="lockScreen"
        *ngIf="!areNoPolicies"
      ></app-loggedin-sidenav>
      <ng-container *ngIf="showLoyaltyBanner">
        <app-loyalty-banner [ngClass]="{ 'mobile-hidden': shouldApplyMobileHiddenForLoyaltyBanner() }"></app-loyalty-banner>
      </ng-container>
    </div>
    <div class="col pl-0 pr-0">
      <div class="row mr-0 ml-0">
        <app-validate-customer-modal
          *ngIf="showValidateCustModal"
          [title]="validateCustomerTitle"
          (closeModal)="closeModal()"
        ></app-validate-customer-modal>
        <app-paperles-popup
          *ngIf="showPaperlessPopup && existMAPolicy"
        ></app-paperles-popup>
        <div class="col-md" *ngIf="leakbot && leakbotToggle">
          <app-myinsurance-leakbot></app-myinsurance-leakbot>
        </div>
      </div>
      <div
        class="hide-in-desktop mobile-quick-links"
        *ngIf="myInsurence && showQuickLinks"
      >
        <section>
          <app-quick-links [policies]="policies"></app-quick-links>
        </section>
      </div>
      <div class="row no-margin">
        <div
          class="col-md col-12 main-column"
          [ngClass]="{
            'policy-card-column': !isAcmic && onDashboard,
            'home-page-width': onHomePage()
          }"
        >
          <mapfre-alert
            *ngIf="showAlert"
            [closeButton]="true"
            [notTop]="false"
          ></mapfre-alert>
          <router-outlet></router-outlet>
        </div>
        <div
          class="col-sm-auto col-12 column-misc padding-bottom pb4"
          [ngClass]="{ 'hide-in-mobile': showQuickLinks }"
          *ngIf="reportClaim"
        >
          <mapfre-card
            [singleCard]="false"
            [additionalClasses]="'claims-dashboard-sidebar nav-content-card'"
          >
            <ng-container *ngIf="showQuickLinks !== undefined">
              <ng-container *ngIf="showQuickLinks; else reportClaimSec">
                <section class="hide-in-mobile">
                  <app-quick-links [policies]="policies"></app-quick-links>
                </section>
              </ng-container>
              <ng-template #reportClaimSec>
                <app-claims-report [placement]="'noclaims'"></app-claims-report>
              </ng-template>
            </ng-container>
          </mapfre-card>
        </div>
      </div>

      <ng-container
        *ngIf="!isAcmic && showBanner && !mobileMessage && showAppBanner"
      >
        <div class="dashboard-banner-container">
          <div class="banner-close nowrap" (click)="closeAppBanner()">
            {{ 'DONT_SHOW_AGAIN' | translate }}
            <img
              src="./assets/img/images/icon-close.svg"
              alt="close banner icon"
            />
          </div>
          <div class="mobile-app-container">
            <div class="go-mapfre-container">
              <div class="fs-24 fw-500 lh-31">{{ 'Go Mapfre App' }}</div>
              <div class="mt-2 mb-3">
                {{ 'Manage your insurance, make payments, claims, and more!' }}
              </div>
              <div class="">
                <a [href]="iosURL" target="_blank" rel="noopener">
                  <img
                    src="./assets/img/images/banner_apple_app_link.svg"
                    alt="Visit Apple store"
                    class="mr-2"
                  />
                </a>
                <a [href]="androidURL" target="_blank" rel="noopener">
                  <img
                    src="./assets/img/images/banner_google_app_link.svg"
                    alt="Visit Google store"
                  />
                </a>
              </div>
            </div>
            <div class="">
              <img src="./assets/img/images/iPhone 14.svg" alt="mobile app" />
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-container *ngIf="!isAcmic && showBanner && !mobileMessage && showAppBanner">
  <div class="banner-app-row"></div>
</ng-container>